function accordion() {
    const $$components = $$('.accordion');

    if (!$$components.length) return;

    $$components.forEach(($component) => {
        const $toggleAllButton = $component.querySelector('.accordion__toggle-all-btn');
        const $announcer = $component.querySelector('.accordion__announcer');

        const toggleAllButtonText = {
            expand: $toggleAllButton ? $toggleAllButton.getAttribute('data-expand-text') : '',
            collapse: $toggleAllButton ? $toggleAllButton.getAttribute('data-collapse-text') : ''
        };

        const announcerText = {
            expanded: $announcer ? $announcer.getAttribute('data-expanded-text') : '',
            collapsed: $announcer ? $announcer.getAttribute('data-collapsed-text') : ''
        };

        const items = $$('[data-toggle]', $component).map((el) => {
            return {
                toggle: toggle(el.dataset.toggle),
                el
            };
        });

        const announce = (state = 'expanded') => {
            if (!$announcer) return;
            const announceCount = items.length;
            const announceText = state === 'expanded' ?
                localizationMachine(announcerText.expanded, [announceCount]) :
                localizationMachine(announcerText.collapsed, [announceCount]);
            $announcer.innerText = announceText;
        };

        const setToggleButtonLabel = (state = 'expanded') => {
            if (!$toggleAllButton) return;
            const $toggleAllButtonLabel = $toggleAllButton.querySelector('.btn__text');
            const ariaExpanded = state === 'expanded' ? 'true' : 'false';
            const newLabelText = state === 'expanded' ? 'collapse' : 'expand';

            $toggleAllButtonLabel.innerText = toggleAllButtonText[newLabelText];
            $toggleAllButton.setAttribute('aria-expanded', ariaExpanded);
        };

        const collapseSiblings = (item) => {
            items.filter(x => x.el !== item.el).forEach(x => x.toggle.collapse());
        };

        items.forEach((item) => {
            item.toggle.on('expand', (el, trigger, msg) => {
                if (!msg || !msg.expandAll) {
                    collapseSiblings(item);
                }
            });

            if ($toggleAllButton) {
                item.toggle.on('collapse', () => {
                    setToggleButtonLabel('collapsed');
                });
            }
        });

        if ($toggleAllButton) {
            $toggleAllButton.addEventListener('click', () => {
                const expandedItems = items.filter(item => item.toggle.isVisible());
                const shouldCollapse = items.length === expandedItems.length;
                const state = shouldCollapse ? 'collapsed' : 'expanded';

                // Toggle items
                items.forEach((item) => {
                    if (shouldCollapse) {
                        item.toggle.collapse();
                    } else {
                        item.toggle.expand({
                            expandAll: true
                        });
                    }
                });

                // Set label on button
                setToggleButtonLabel(state);

                // Announce text for screen readers
                announce(state);
            });
        }
    });
}

//Custom Function
$(".collapsed").on("click", function () {
    setTimeout(function () {
        $(".panel-collapse").removeAttr("aria-expanded").focus();
    }, 50)
});


var collapseTwoBtn= $("#faqQuestionAnswers button").first();
var collapseThreeBtn= $("#faqQuestionAnswers button").last(); 

collapseTwoBtn.on('click', function () {
    $('#collapseThree').removeAttr('tabindex')
    $('#collapseTwo').focus()   
});

collapseThreeBtn.on('click', function () {
        $('#collapseThree').prop('tabindex', -1);
        $('#collapseTwo').focus()
});